import { FindeksRequestService } from '@/services/admin/FindeksRequestService'
import { QueryBuilder } from '@/utilities/queryBuilder'

export const namespaced = true

export const state = {
  findeks_requests: []
}

export const mutations = {
  SET_FINDEKS_REQUESTS(state, findeksRequests) {
    state.findeks_requests = findeksRequests
  }
}

export const actions = {
  getFindeksRequests({ commit }, application) {
    return new Promise(resolve => {
      let findeksRequestService = new FindeksRequestService()

      let queryBuilder = new QueryBuilder()
      let newQuery = queryBuilder
        .include(
          'findeksReport.individual.beans',
          'findeksReport.individual.vysBeans',
          'findeksReport.commercial.beans',
          'findeksReport.commercial.vysBeans'
        )
        .get()

      findeksRequestService.getFindeksRequests(application, newQuery).then(response => {
        commit('SET_FINDEKS_REQUESTS', response.data)
        resolve(response.data)
      })
    })
  }
}
